import { Box, Typography, Grid, Button, Card, TextField } from "@mui/material";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { useState } from "react";
import { useEffect } from "react";
import CustomSnackbar from "../../../newTestPreo/components/snackbar/Snackbar";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

// Map labels to local image files
const imageMap = {
  IELTS: "/SAPImages/exams/ielts.png",
  PTE: "/SAPImages/exams/pte.png",
  TOEFL: "/SAPImages/exams/toefl.png",
  "No Exam": "/SAPImages/exams/noexam.png",
  GMAT: "/SAPImages/exams/gmat.png",
  GRE: "/SAPImages/exams/gre.png",
  SAT: "/SAPImages/exams/sat.png",
  "Other Exams": "/SAPImages/exams/otherexams.png",
};

function ExamHistoryForm(props, ref) {
  const [englishTests, setEnglishTests] = useState([]);
  const [academicTests, setAcademicTests] = useState([]);
  const [selectedEnglish, setSelectedEnglish] = useState(null);
  const [selectedAcademic, setSelectedAcademic] = useState(null);
  const [otherEnglishExam, setOtherEnglishExam] = useState("");
  const [otherAcademicExam, setOtherAcademicExam] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}english-tests`)
      .then((response) => response.json())
      .then((data) => {
        setEnglishTests(data?.data);
      })
      .catch((error) => {
        console.error("Error fetching tests:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}other-tests`)
      .then((response) => response.json())
      .then((data) => {
        setAcademicTests(data?.data);
      })
      .catch((error) => {
        console.error("Error fetching tests:", error);
      });
  }, []);

  useImperativeHandle(ref, () => ({
    validate: () => {
      if (!selectedEnglish) {
        showSnackbar("Please select english test");
        return false;
      }

      if (selectedEnglish == -2 && !otherEnglishExam) {
        showSnackbar("Please specify other English Exam");
        return false;
      }
      if (!selectedAcademic) {
        showSnackbar("Please select academic test");
        return false;
      }

      if (selectedAcademic == -2 && !otherAcademicExam) {
        showSnackbar("Please specify other Academic Exam");
        return false;
      }
      return true;
    },

    getData: () => ({
      english_exam_id: selectedEnglish > 0 ? selectedEnglish : null,
      academic_exam_id: selectedAcademic > 0 ? selectedAcademic : null,
      other_english_exam: otherEnglishExam?.trim() ? otherEnglishExam : null,
      other_academic_exam: otherAcademicExam?.trim() ? otherAcademicExam : null,
    }),
  }));

  return (
    <Box
      className="scrollbar-hide"
      sx={{
        maxHeight: "70vh",
        overflowY: "auto",
        pr: 1, // prevent content cutoff
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#bdbdbd",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#9e9e9e",
        },
      }}
    >
      {/* English Exams */}
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontStyle: "normal",
          fontSize: "medium",
          lineHeight: "100%",
          letterSpacing: "0px",
          verticalAlign: "middle",
          mb: 2,
          color: "#111111",
        }}
      >
        Have you previously given any English exam(s)?
      </Typography>

      <Grid container spacing={2}>
        {englishTests.map((test) => (
          <Grid item xs={12} sm={6} md={4} key={test.id}>
            <Button
              fullWidth
              onClick={() => setSelectedEnglish(test.id)}
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
                color: selectedEnglish === test.id ? "#572575" : "#000",
                backgroundColor:
                  selectedEnglish === test.id ? "#F9EEFF" : "#fff",
                "&:hover": {
                  backgroundColor:
                    selectedEnglish === test.id ? "#F9EEFF" : "#f5f5f5",
                },
                border: "1px solid #572575",
                borderColor:
                  selectedEnglish === test.id ? "#572575" : "#E0E0E0",
                textTransform: "none",
                fontFamily: "inter",
                fontSize: "16px",
                fontWeight: selectedEnglish === test.id ? 600 : 400,
                p: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <img
                src={imageMap[test.name] || "/SAPImages/exams/gmat.png"}
                alt={test.name}
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
              />
              {test.name}
            </Button>
          </Grid>
        ))}

        {selectedEnglish === -2 && (
          <Grid item xs={12}>
            <Card
              sx={{
                backgroundColor: "#F9EEFF",
                padding: 3,
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500, // Medium = 500
                  fontStyle: "normal", // Medium is handled by fontWeight
                  fontSize: "medium",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  mb: 2,
                  color: "#111111",
                }}
              >
                Specify your English exam
              </Typography>

              <Box
                sx={{
                  borderBottom: "2px dotted #C4C4C4",
                  mb: 2,
                }}
              />

              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Enter your English exam name (eg. Duolingo, CAE)"
                value={otherEnglishExam}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(/[^A-Za-z ]/g, ""); // only alphabets + space
                  setOtherEnglishExam(onlyLetters);
                }}
                sx={{
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B035E",
                    },
                  },
                }}
              />
            </Card>
          </Grid>
        )}
      </Grid>

      {/* Academic Exams */}
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 500,
          fontStyle: "normal",
          fontSize: "medium",
          lineHeight: "100%",
          letterSpacing: "0px",
          verticalAlign: "middle",
          mb: 2,
          color: "#111111",
          mt: 2,
        }}
      >
        Have you previously given any Academic exam(s)?
      </Typography>

      <Grid container spacing={2}>
        {academicTests.map((test) => (
          <Grid item xs={12} sm={6} md={4} key={test.id}>
            <Button
              fullWidth
              onClick={() => {
                setSelectedAcademic(test.id);
              }}
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
                color: selectedAcademic === test.id ? "#572575" : "#000",
                backgroundColor:
                  selectedAcademic === test.id ? "#F9EEFF" : "#fff",
                "&:hover": {
                  backgroundColor:
                    selectedAcademic === test.id ? "#F9EEFF" : "#f5f5f5",
                },
                border: "1px solid #572575",
                borderColor:
                  selectedAcademic === test.id ? "#572575" : "#E0E0E0",
                textTransform: "none",
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: selectedAcademic === test.id ? 600 : 400,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                p: 2,
              }}
            >
              <img
                src={imageMap[test.name] || "/SAPImages/exams/gmat.png"}
                alt={test.name}
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
              />
              {test.name}
            </Button>
          </Grid>
        ))}

        {selectedAcademic === -2 && (
          <Grid item xs={12}>
            <Card
              sx={{
                backgroundColor: "#F9EEFF",
                padding: 3,
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px #0000001A",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  fontStyle: "normal",
                  fontSize: "medium",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  verticalAlign: "middle",
                  mb: 2,
                  color: "#111111",
                }}
              >
                Specify your Academic exam
              </Typography>

              <Box
                sx={{
                  borderBottom: "2px dotted #C4C4C4",
                  mb: 2,
                }}
              />

              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Enter your academic exam name (e.g., CAT, JEE)"
                value={otherAcademicExam}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(/[^A-Za-z ]/g, ""); // only alphabet + space
                  setOtherAcademicExam(onlyLetters);
                }}
                sx={{
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3B035E",
                    },
                  },
                }}
              />
            </Card>
          </Grid>
        )}
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
}

export default forwardRef(ExamHistoryForm);
